import script from "./NotFound.vue?vue&type=script&setup=true&lang=js"
export * from "./NotFound.vue?vue&type=script&setup=true&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=7d956e1c&lang=css"

const __exports__ = script;

export default __exports__